export const version = 'kunde-v1.20.0-SNAPSHOT-61a1e5af5ea25fd18196e252c9dc63f08e28cc95';